module.exports = __webpack_public_path__ + "img/newsitem-defaultimg.4c8d20b0.jpg";